import src from "IMAGE";
export default { src, width: 1024, height: 123, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRkYAAABXRUJQVlA4TDkAAAAvBwAAEM1VICICEeGBAAEAAAAAnL8BAQAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYTDp6BwIA"};
